/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Alessio Pani <alessio.pani@opensoftdev.com>
 */
import 'APP_THEME/_common/start_page/common';
import 'resources/less/themes/base/pages/product_category.less';

import CategoryPageView from 'assets/js/modules/pages/product_category/view/index';

$(function() {
    new CategoryPageView();
});
